export const macStyle = {
  default: {
    normal: {
      'border-color': '#C8C8C8 #C2C2C2 #ACACAC',
      'background-image': 'none',
      color: 'initial'
    },
    mousedown: {
      'border-color': '#4C98FE #125EED #0010DB',
      'background-image': '-webkit-linear-gradient(top, #6CB3FA 0%, #0564E3 100%)',
      color: 'rgba(255, 255, 255, 0.9)'
    }
  },
  blue: {
    normal: {
      'border-color': '#4CA2F9 #267FFC #015CFF',
      'background-image': '-webkit-linear-gradient(top, #6cb3fa 0%, #087eff 100%)',
      color: 'rgba(255, 255, 255, .9)'
    },
    mousedown: {
      'border-color': '#247fff #125eed #003ddb',
      'background-image': '-webkit-linear-gradient(top, #6CB3FA 0%, #0564E3 100%)',
      color: 'rgba(255, 255, 255, 0.9)'
    }
  },
  pink: {
    normal: {
      'border-color': '#ff4a53 #ff2852 #ff0031',
      'background-image': '-webkit-linear-gradient(top, #FF365D 0%, #fc0030 100%)',
      color: 'rgba(255, 255, 255, .9)'
    },
    mousedown: {
      'border-color': '#ff4053 #ed1141 #ce0026',
      'background-image': '-webkit-linear-gradient(top, #ff2d55 0%, #ff0030 100%)',
      color: 'rgba(255, 255, 255, 0.9)'
    }
  }
};
